import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMetrodelaciudaddemexicoComponent } from './simple-icons-metrodelaciudaddemexico.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMetrodelaciudaddemexicoComponent ],
    exports:      [ SimpleIconsMetrodelaciudaddemexicoComponent ],
    bootstrap:    []
})
export class SimpleIconsMetrodelaciudaddemexicoModule {}
